export enum ObjectLockUrl {
  CREATE = '/lock',
  LOCK = '/lock/{objectType}/{objectId}{?discriminator}',
}
